import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '../../../../services/data.service';

@Component({
	selector: 'teachers-detail-basic-information',
	templateUrl: './basic.html'
})
export class TeachersDetailBasicInformation {
	@Input() form: FormGroup;
	@Input() action: string;

	public constructor(
		private dataService: DataService
	) {

	}
}


// WEBPACK FOOTER //
// ./src/pages/teachers/detail/basic/basic.ts